<template>
  <div class="feedContainer">
    <feed-item-component v-for="item in items" :key="item.id" :item="item" :useSmallColumns="useSmallColumns" />
    <div v-if="items && items.length > 0" id="fader">
      <div id="download-app-area">
        <p id="download-app-header">{{ t('see-more') }}</p>
        <a @click="openApp" id="download-app-button">
          <p id="download-app-button-text">{{ t('download-app') }}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import { Item } from '@/dto/Item'
import FeedItemComponent from '@/views/components/feed/FeedItemComponent.vue'
import { useI18n } from 'vue-i18n'
import * as router from '@/router'

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<Array<Item>>,
      default: [] as PropType<Array<Item>>
    }
  },

  components: {
    FeedItemComponent
  },

  methods: {
    changeCellWidth() {
      this.useSmallColumns = (window.innerWidth < 768)
    },

    openApp() {
      router.default.push({ name: router.routeNames.DOWNLOAD })
    }
  },

  setup() {
    const useSmallColumns = ref(window.innerWidth < 768)

    const { t } = useI18n({
      inheritLocale: true,
      scope: 'locale'
    })

    return { useSmallColumns, t }
  },

  mounted() {
    window.addEventListener('resize', this.changeCellWidth)
  },

  unmounted() {
    window.removeEventListener('resize', this.changeCellWidth)
  }
})
</script>

<style lang="sass" scoped>
$breakpoint-md: 768px

$grid-row-height: 10px
$grid-card-width: 232px + 10px //margin
$grid-card-width-small: 168px + 10px // margin

.feedContainer
  position: relative
  display: grid
  grid-template-columns: repeat(auto-fill, $grid-card-width)
  grid-auto-rows: $grid-row-height
  justify-content: center
  @media (max-width: $breakpoint-md)
    grid-template-columns: repeat(auto-fill, $grid-card-width-small)

#fader
  pointer-events: none
  position: absolute
  width: 100%
  height: 750px
  bottom: 0
  background: linear-gradient(0deg, $color_background, #00000000)

#download-app-area
  position: absolute
  bottom: 0
  width: 100%

#download-app-header
  text-align: center
  font-weight: 500
  font-size: 1.7em
  @media (max-width: $breakpoint-md)
    font-size: 1.2em

#download-app-button
  pointer-events: all
  margin-top: 6px
  background-color: $success
  text-align: center
  display: table
  margin-left: auto
  margin-right: auto
  padding: 12px 16px 12px 16px
  border-radius: 12px
  cursor: pointer

#download-app-button-text
  margin: 0
  font-weight: 500
  color: $color_background

</style>

<i18n>
{
  "de": {
    "download-app": "Download App",
    "see-more": "Du möchtest mehr sehen?"
  },

  "en": {
    "download-app": "Download App",
    "see-more": "Wanna see more?"
  }
}
</i18n>
